var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.481 0H8.53333C3.08622 0 0 3.08622 0 8.53333V23.4667C0 28.9138 3.08622 32 8.53333 32H23.481C28.928 32 32 28.9138 32 23.4667V8.53333C32 3.08622 28.928 0 23.481 0Z",
    fill: "#FFCC00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7041 9.94715C18.7041 11.798 20.2067 13.2984 22.0603 13.2984C22.2644 13.2974 22.468 13.2778 22.6685 13.2398V19.8838C22.6685 22.6789 21.0197 24.3325 18.2205 24.3325H12.1238C9.31722 24.3325 7.66846 22.6789 7.66846 19.8838V13.7959C7.66846 11.0008 9.31722 9.33252 12.1238 9.33252H18.7627C18.7234 9.53502 18.7037 9.74086 18.7041 9.94715ZM16.9601 18.413L19.3416 15.3399V15.3252C19.5455 15.0513 19.4935 14.6649 19.2244 14.4544C19.0941 14.3539 18.9286 14.3104 18.7657 14.3339C18.6027 14.3573 18.4562 14.4457 18.3597 14.5789L16.3519 17.1618L14.0656 15.3618C13.9351 15.2601 13.769 15.2152 13.605 15.2372C13.4409 15.2593 13.2926 15.3464 13.1936 15.4789L10.7315 18.6544C10.6449 18.7624 10.5983 18.8968 10.5996 19.0349C10.5853 19.3143 10.7617 19.568 11.0288 19.6524C11.2959 19.7367 11.5863 19.6303 11.7354 19.3935L13.7945 16.7301L16.0808 18.5228C16.2108 18.6276 16.378 18.6751 16.5438 18.6544C16.7096 18.6338 16.8599 18.5466 16.9601 18.413Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2508 11.8332C23.4014 11.8332 24.3341 10.9004 24.3341 9.74984C24.3341 8.59924 23.4014 7.6665 22.2508 7.6665C21.1002 7.6665 20.1675 8.59924 20.1675 9.74984C20.1675 10.9004 21.1002 11.8332 22.2508 11.8332Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductCategory);
export default __webpack_public_path__ + "static/media/product-category.f348163831efe5f429ea7ca219be1b56.svg";
export { ForwardRef as ReactComponent };